import { Inject, Injectable } from '@angular/core';
import {
  TRANSACIONAL_EVENTS_REPOSITORY,
  TransactionalEventsRepository,
} from '@core/repositories/transactional-events.repository';
import { TransactionalEvent } from '@shared/interfaces/transactional-event';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TransactionalEventsService {
  constructor(
    @Inject(TRANSACIONAL_EVENTS_REPOSITORY)
    protected repository: TransactionalEventsRepository
  ) {}

  getItems(): Observable<any> {
    return this.repository.getItems();
  }

  add(transactionalEvent: TransactionalEvent): Observable<any> {
    return this.repository.add(transactionalEvent);
  }

  edit(transactionalEvent: TransactionalEvent): Observable<any> {
    return this.repository.edit(transactionalEvent);
  }

  delete(item: any): Observable<any> {
    return this.repository.delete(item);
  }
}
